import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import PropTypes from "prop-types";
const HeroSection = ({ handleGetStarted, setShowContactForm, heroImage }) => {
  return (
    <motion.section
      className="relative min-h-screen flex flex-col items-center justify-center px-4 py-20"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="absolute inset-0 z-0 bg-gradient-to-br from-peachYellow/5 to-white"></div>
      <div className="absolute inset-0 z-0 opacity-5">
        <div className="absolute top-20 left-20 w-64 h-64 rounded-full bg-peachYellow/20 blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 rounded-full bg-roseBrown/20 blur-3xl"></div>
      </div>

      <div className="container mx-auto z-10 text-center">
        <motion.h1
          className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-primary pb-2"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Hire Smart. Hire Fast. Hire Real.
        </motion.h1>

        <motion.p
          className="text-xl md:text-2xl text-gray-700 mb-10 max-w-3xl mx-auto"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Go beyond the resume and pre-screen candidates with one-way video
          responses that save time and help you find the perfect fit.
        </motion.p>

        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <button
            onClick={handleGetStarted}
            className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-peachYellow rounded-full overflow-hidden transition-all duration-300 ease-in-out hover:bg-salmonPink hover:scale-105 hover:shadow-lg"
          >
            <span className="relative z-10 flex flex-col items-center">
              <span className="flex items-center">
                Try For Free
                <ArrowRightIcon className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </span>
            <span className="absolute inset-0 bg-gradient-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
          </button>

          <button
            onClick={() => setShowContactForm(true)}
            data-testid="hero-contact-button"
            className="ml-4 px-8 py-4 text-lg font-bold text-ashGray border-2 border-ashGray rounded-full transition-all duration-300 hover:bg-ashGray/10 hover:scale-105"
          >
            Contact Us
          </button>
        </motion.div>
      </div>

      <motion.div
        className="mt-16 max-w-4xl mx-auto relative"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <div className="absolute inset-0 -m-4 bg-gradient-to-br from-peachYellow/10 to-roseBrown/10 rounded-xl blur-md"></div>
        <img
          src={heroImage}
          alt="Video Interview Platform"
          className="w-full h-auto rounded-lg shadow-2xl border border-gray-200 relative z-10"
        />
        <div className="text-sm text-gray-500 mt-2 relative z-10">
          Photo by{" "}
          <a
            href="https://unsplash.com/@brookecagle?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
            className="hover:underline"
          >
            Brooke Cagle
          </a>{" "}
          on{" "}
          <a
            href="https://unsplash.com/photos/smiling-man-using-laptop-computer-while-sitting-on-black-leather-sofa-LCcFI_26diA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
            className="hover:underline"
          >
            Unsplash
          </a>
        </div>
      </motion.div>
    </motion.section>
  );
};

HeroSection.propTypes = {
  handleGetStarted: PropTypes.func.isRequired,
  setShowContactForm: PropTypes.func.isRequired,
  heroImage: PropTypes.string.isRequired,
};

export default HeroSection;
